import React, { useContext, useEffect, useState } from "react";
import './showLocations.style.scss';
import { AccountContext } from '../../../Contexts/main.context';
import EditCitationModal from "./EditCitation/EditCitation.component";

const CitationsList = ({ citations = [] }) => {
     // Sort by newest date (assuming ISO format or valid Date string)
     const context = useContext(AccountContext);
     const { activeClient, updateMasked } = context || {};
     // const sortedCitations = [...citations].sort((a, b) => new Date(b.date) - new Date(a.date));
     const [activeCitations, setActiveCitations] = useState([]);
     const [activeListCitations, setActiveListCitations] = useState([]);
     const [potentialCitations, setPotentialCitations] = useState([]);
     const [duplicateCitations, setDuplicateCitations] = useState([])
     const [editingCitation, setEditingCitation] = useState(null);

     const getCitations = async () => {
          const sendData = { clientID: activeClient.ID, script: 'getcitations' }
          try {
               const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/special.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(sendData),
               });

               const data = await response.json();
               const activeFiltered = data.filter(citation => citation.citationStatus?.toLowerCase() === 'active');
               const potentialFiltered = data.filter(citation => citation.citationStatus?.toLowerCase() === 'potential');
               const duplicateFiltered = data.filter(citation => citation.citationStatus?.toLowerCase() === 'duplicate');
               setActiveListCitations(activeFiltered);
               setPotentialCitations(potentialFiltered);
               setDuplicateCitations(duplicateFiltered);
               setActiveCitations(activeFiltered);
          } catch (error) {
               alert("Error Retrieving Citations");
          }
     }

     useEffect(() => {
          getCitations();
     }, [activeClient])


     const [linkPressed, setLinkPressed] = useState('');

     const openLink = (inval, ID) => {
          setLinkPressed(ID);
          window.open(inval, '_blank');
     };

     const finishEdit = () => {
          updateMasked(false); // ✅ remove screen mask
          setEditingCitation(null);
          getCitations();
     };


     const openEditModal = (citation) => {
          updateMasked(true); // ✅ mask the screen
          setEditingCitation(citation);
     };

     const checkIndex = async (ID) => {
          const checkRecord = activeCitations.find(needle => needle.ID === ID);
          console.log(checkRecord);
          if (!checkRecord || !checkRecord.CitationLink) return;

          try {
               const res = await fetch("https://www.lgfantasy.ca/Citations/PHP/special.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                         script: "checkIndex",
                         link: checkRecord.CitationLink
                    }),
               });

               const result = await res.json();
               const whatResult = result.indexed === true;
               if (result.indexed !== true) {
                   alert(`🔍 ${checkRecord.CitationLink} is ${whatResult ? 'indexed ✅' : 'not indexed ❌'}`);
                   fetch("https://www.lgfantasy.ca/Citations/PHP/special.php", {
                         method: "POST",
                         headers: { "Content-Type": "application/json" },
                         body: JSON.stringify({
                              script: "setIndexed",
                              citationID: checkRecord.ID,
                              indexed: "No"
                         }),
                    });
                    // Update local state for immediate UI feedback
                    setActiveCitations(prev =>
                         prev.map(c =>
                              c.ID === checkRecord.ID
                                   ? { ...c, citationIndexed: "No" }
                                   : c
                         )
                    );
               } else {
                    alert(`🔍 ${checkRecord.CitationLink} is ${whatResult ? 'indexed ✅' : 'not indexed ❌'}`);
                    fetch("https://www.lgfantasy.ca/Citations/PHP/special.php", {
                         method: "POST",
                         headers: { "Content-Type": "application/json" },
                         body: JSON.stringify({
                              script: "setIndexed",
                              citationID: checkRecord.ID,
                              indexed: "Yes"
                         }),
                    });
                    // Update local state for immediate UI feedback
                    setActiveCitations(prev =>
                         prev.map(c =>
                              c.ID === checkRecord.ID
                                   ? { ...c, citationIndexed: "IND" }
                                   : c
                         )
                    );
               }

          } catch (error) {
               console.error("Index check failed:", error);
          }
     };



     return (
          <>
               <div className="container-fluid bg-light">
                    <div className="justify-content-center p-4 fs-5 fw-bold mb-2 alert-dark d-flex">
                         <div>
                             New Current Location - {activeClient.companyName} - {activeClient.theLocation}
                         </div>
                         <div className="ps-3 text-purple fw-bold">[{activeCitations.length} Citations]</div>
                    </div>
                    <div className="d-flex justify-content-center gap-3 mb-3">
                         <button
                              className={`btn ${activeListCitations.length === activeCitations?.length ? 'btn-success' : 'btn-outline-success'}`}
                              onClick={() => setActiveCitations(activeListCitations)}
                         >
                              Active
                         </button>
                         <button
                              className={`btn ${potentialCitations.length === activeCitations?.length ? 'btn-primary' : 'btn-outline-primary'}`}
                              onClick={() => setActiveCitations(potentialCitations)}
                         >
                              Potential
                         </button>
                         <button
                              className={`btn ${duplicateCitations.length === activeCitations.length ? 'btn-danger' : 'btn-outline-danger'}`}
                              onClick={() => setActiveCitations(duplicateCitations)}
                         >
                              Duplicate
                         </button>
                    </div>
                    <div className="citations-list">
                         <div className="d-flex bg-navy text-lemon fs-6 p-4">
                              <div className="col-10">Source</div>
                              <div className="col-1 text-center">S</div>
                              <div className="col-4 text-center">Status</div>
                              <div className="col-7 text-center"></div>
                              <div className="col-4 text-center">Name. NAP</div>
                              <div className="col-5 text-center">Add. NAP</div>
                              <div className="col-5 text-center">Ph. NAP</div>
                              <div className="col-5 text-center">Post. NAP</div>
                              <div className="flex-grow-1 text-center fw-bold text-white">
                                   Index/Edit Rob Only
                              </div>
                         </div>
                         {activeCitations.map((citation, index) => {
                              const statusClassMap = {
                                   active: 'bg-success',
                              };

                              const status = citation.citationStatus?.toLowerCase();
                              const statusClass = statusClassMap[status] || statusClassMap.default;

                              return (
                                   <div key={citation.ID || index}>
                                        <div className={`d-flex px-4 py-2 justify-content-start align-items-center border-bottom border-2 border-navy ${citation.ID === linkPressed ? 'alert-purple' : ''}`}>
                                             <div className="col-10">
                                                  <div>{citation.Domain}</div>
                                             </div>
                                             <div className="col-1 text-center fs-7">
                                                  {citation.source === 'Domain'
                                                       ? 'L'
                                                       : citation.source === 'Monday'
                                                       ? 'M'
                                                       : citation.source === 'Bright'
                                                       ? 'B'
                                                       : '?'}
                                             </div>
                                             <div className="col-4">
                                                  <div className={`text-center text-light badge col-40 offset-4 p-2 ${
                                                       citation.citationStatus?.toLowerCase() === 'active'
                                                            ? 'bg-success'
                                                            : citation.citationStatus?.toLowerCase() === 'potential'
                                                            ? 'bg-primary'
                                                            : citation.citationStatus?.toLowerCase() === 'duplicate'
                                                            ? 'bg-danger'
                                                            : ''
                                                  }`}>
                                                       <div className="text-uppercase">
                                                            {citation.citationStatus}
                                                       </div>
                                                  </div>
                                             </div>
                                             <div className="col-7 text-center">
                                                  -
                                                  {/* {['', '-', 'unknown'].includes(citation.CitationValue?.toString().toLowerCase())
                                                       ? '?'
                                                       : citation.CitationValue} */}
                                             </div>
                                             <div className={`col-4 text-center ${citation.BusinessNameIssue?.toLowerCase() === 'yes' ? 'alert-danger' : ''}`}>
                                                  {citation.BusinessNameIssue?.toLowerCase() === 'yes' ? 'Yes' : '-'}
                                             </div>
                                             <div className={`col-5 text-center ${citation.Address_Issue?.toLowerCase() === 'yes' ? 'alert-danger' : ''}`}>{citation.Address_Issue ? 'Yes' : '-'}</div>
                                             <div className={`col-5 text-center ${citation.PhoneNumberIssue?.toLowerCase() === 'yes' ? 'alert-danger' : ''}`}>{citation.PhoneNumberIssue ? 'Yes' : '-'}</div>
                                             <div className={`col-5 text-center ${citation.PostalCodeIssue?.toLowerCase() === 'yes' ? 'alert-danger' : ''}`}>{citation.PostalCodeIssue ? 'Yes' : '-'}</div>
                                             <div className="col-7 d-flex justify-content-end gap-1">
                                                  <div className="col-18">
                                                       <div className="btn btn-primary col-48" onClick={() => openLink(citation.CitationLink, citation.ID)}>Link</div>
                                                  </div>
                                                  <div className="col-18">
                                                       <div
                                                            className={`btn col-48 disabled ${
                                                                 citation.citationIndexed === 'No'
                                                                      ? 'btn-danger'
                                                                      : citation.citationIndexed === 'ER'
                                                                      ? 'btn-warning'
                                                                      : citation.citationIndexed === 'Yes'
                                                                      ? 'btn-success'
                                                                      : citation.citationIndexed === 'IND'
                                                                      ? 'btn-primary'
                                                                      : 'btn-secondary'
                                                            }`}
                                                            onClick={() => checkIndex(citation.ID)}
                                                       >
                                                            {citation.citationIndexed}
                                                       </div>
                                                  </div>
                                                  <button
                                                       className="btn btn-warning disabled"
                                                       onClick={() => openEditModal(citation)}
                                                  >
                                                       Edit
                                                  </button>
                                                  {editingCitation && (
                                                       <EditCitationModal
                                                            citation={editingCitation}
                                                            onClose={() => finishEdit()}
                                                       />
                                                  )}
                                             </div>
                                        </div>
                                   </div>
                              );
                         })}

                    </div>
               </div>
          </>
     );
};

export default CitationsList;
